import {Component, OnInit} from '@angular/core';
import {
  Aangifte,
  AangifteRapport, BokkzAlgDataService, IncomeTaxEntity,
  OpbouwHeffingskortingen, OpbouwVoorheffingen,
  SpecificatieHeffingskortingen, SpecificatieVoorheffingen
} from "@snelstart-ventures/fiscaal/domain-logic";
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormBuilder} from "@angular/forms";
import { SharedUiDetailsModule } from '@snelstart/ui-details';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-spec-voorheffingen',
  templateUrl: './spec-voorheffingen.component.html',
  styleUrls: ['./spec-voorheffingen.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiDetailsModule
  ]
})
export class SpecVoorheffingenComponent implements OnInit {
    aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;
    specVoorheffingenFormGroup = this.fb.group<AangifteRapport>({});
    specVoorheffingen = {} as AangifteRapport;

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private fb: FormBuilder) {
        this.specVoorheffingenFormGroup = this.fb.group<AangifteRapport>(({
            specificatieVoorheffingen: this.fb.group<SpecificatieVoorheffingen>(({
                opbouw: this.fb.group<OpbouwVoorheffingen>(({
                    totaleVoorheffingen: null as unknown as number,
                    loonbelastingAlsOnderdeelVanWinst: null as unknown as number,
                    loonbelastingTegenwoordigeDienstbetrekking: null as unknown as number,
                    loonbelastingVroegereDienstbetrekking: null as unknown as number,
                    dividendbelasting: null as unknown as number,
                } as OpbouwVoorheffingen))
            } as SpecificatieVoorheffingen))
        } as AangifteRapport))
    }

    public ngOnInit(): void {
        this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte as Aangifte;
                this.aangifte = aangifte;
                this.dataService.aangifteRapport.subscribe((value) => {
                    this.specVoorheffingen = value;
                    this.specVoorheffingenFormGroup.patchValue(this.specVoorheffingen)
                });
            }
        })
    }

}

